import { TextOverflowTooltip } from '@ipfabric/ui-components/Tooltip/TextOverflowTooltip';
import type { ReferenceMetaInfo } from 'components/SecuritySchema/model/SecuritySchemaNode';
import { renderTestMetaInfo } from 'components/SecuritySchema/nodeComponents/renderTestMetaInfo';
import type { ReactNode } from 'react';
import type { AppTranslations } from 'translations/translations';

export const renderReferenceMetaInfo = (
  referenceMetaInfo: ReferenceMetaInfo,
  msg: AppTranslations,
): ReactNode => (
  <>
    <TextOverflowTooltip as='p'>
      {msg.securitySchema.test.metaInfo.reference}
      {`: ${referenceMetaInfo.reference.key}`}
    </TextOverflowTooltip>
    {renderTestMetaInfo(referenceMetaInfo, msg)}
    <hr />
  </>
);
